import { c as _c } from "react/compiler-runtime";
import { Icon } from "@/components/formatters/MXPIcon";
interface ChipProps {
  label: string;
  onDelete?: () => void;
  isIcon?: boolean;
  size?: "small" | "large";
  onClick?: () => void;
  isSelected?: boolean;
}
export const Chip = t0 => {
  const $ = _c(12);
  const {
    label,
    isIcon,
    size,
    onDelete,
    onClick,
    isSelected: t1
  } = t0;
  const isSelected = t1 === undefined ? false : t1;
  const t2 = `group flex items-center justify-between bg-yellow-m7 w-fit h-[30px] rounded-full cursor-pointer transition-all duration-300 ease-in-out hover:bg-blue-trmb focus:bg-blue-trmb active:bg-blue-trmb ${size === "small" ? "px-4" : "py-[18px] px-5"} ${isSelected ? "!bg-blue-trmb" : ""}`;
  const t3 = onDelete ? onDelete : onClick;
  const t4 = `text-gray-m9 text-sm not-italic font-medium leading-7 no-underline mr-[14px] inline-block group-hover:text-white group-focus:text-white group-active:text-white ${!isIcon ? "!mr-0" : ""} ${isSelected ? "!text-white" : ""}`;
  let t5;
  if ($[0] !== label || $[1] !== t4) {
    t5 = <span className={t4}>{label}</span>;
    $[0] = label;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== isIcon || $[4] !== label || $[5] !== onDelete) {
    t6 = isIcon && onDelete && <button className="bg-transparent border-none text-gray-m9 group-hover:text-white group-hover:cursor-pointer group-focus:text-white group-focus:cursor-pointer group-active:text-white group-active:cursor-pointer" aria-label={`Remove ${label}`} onClick={e => {
      e.stopPropagation();
      onDelete();
    }}><Icon type="t2u-close" className="t2-chip__close-icon" size={12} /></button>;
    $[3] = isIcon;
    $[4] = label;
    $[5] = onDelete;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t5 || $[10] !== t6) {
    t7 = <div className={t2} onClick={t3}>{t5}{t6}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};